export default class DomainBaseFieldIDs {
    static EntityTypeList_lines_entityType = `lines.entityType`;
    static MasterGroup_forType = `forType`;
    static DocumentBook_documentType = `documentType`;
    static Account_chartWhenDebit = "chartWhenDebit";
    static AUTestDef_phase = "phase";
    static AUPhase_fullHierarchyPath = "fullHierarchyPath";
    static CriteriaDefinition_forType = "forType";
    static CriteriaDefinition_useInList = "useInList";
    static ReportDefinition_reportType = "reportType";
    static DashBoard_details_dashBoardGroup = "details.dashBoardGroup";
    static DashBoardGroup_orderInMenu = "orderInMenu";
    static ReportGroup_orderInMenu = "orderInMenu";
    static ReportDefinition_groupsIds = "groupsIds";
    static CriteriaDefinition_criteria = "criteria";
    static DiscussionRecord_attachment1 = "attachment1";
    static DiscussionRecord_attachment2 = "attachment2";
    static DiscussionRecord_attachment3 = "attachment3";
    static DiscussionRecord_attachment4 = "attachment4";
    static DiscussionRecord_discussion = "discussion";
    static DiscussionRecord_ref1 = "ref1";
    static DiscussionRecord_ref2 = "ref2";
    static DiscussionRecord_date1 = "date1";
    static DiscussionRecord_date2 = "date2";
    static DiscussionRecord_time1 = "time1";
    static DiscussionRecord_time2 = "time2";
    static DocumentBook_printOnSave = "printOnSave";
    static CRMDevelopmentRequest_concernedEntity = "concernedEntity";
    static CRMDevelopmentRequest_applicationLog = "applicationLog";
    static ItemCategory_categoryLevel = "categoryLevel";
}
